import { render } from "./App.vue?vue&type=template&id=3717a6ca"
const script = {}

import "./App.vue?vue&type=style&index=0&id=3717a6ca&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__